"use client";

import * as X from "@/ui";

import { useTravelerHomePage } from "@/providers/strapi/content/types/singleTypes/traveler-home-page";
import ReactMarkdown from "react-markdown";


// const data = {
//   shop: {
//     title: {
//       en: <>Shop in-store <strong className="font-medium">and online</strong></>,
//       fr: <>En magasin <strong className="font-medium">et en ligne</strong></>,
//     },
//     text: {
//       en: "Buy from any store, physical or online, and spend as much or as little as you want. We group your purchases by country to help you meet Customs’ minimums. Smart, right?",
//       fr: "Faites vos achats dans n'importe quelle boutique (mais aussi en ligne) et ce, peu importe le montant. Nous regroupons vos achats pour atteindre les minimums requis par les douanes ! Malin non ?",
//     },
//     cta: {
//       en: "Download the app",
//       fr: "Téléchargez l'application",
//     },
//   },

//   support: {
//     title: {
//       en: <>Best in class <strong className="font-medium">customer support</strong></>,
//       fr: <>Avec le meilleur <strong className="font-medium">service client</strong></>,
//     },
//     text: {
//       en: "Our multilingual team is available 24/7 via in-app chat or phone. We’re here to help—wherever you are, whenever you need us",
//       fr: "Nos équipes multilingues sont disponibles 24/7, via notre chat intégré dans l'app ou par téléphone. Nous sommes proche de vous, pour mieux vous servir.",
//     },
//     cta: {
//       en: "Ask us anything",
//       fr: "Posez-nous toutes vos questions",
//     },
//   },
// };


export function CustomerSupportSection(props: X.PageProps<{
  onDownloadApp: () => void;
}>) {
  return (
    <section className={X.clsx("mt-20 xl:my-20", props.locale === "en" && "xl:mb-36")}>
      <SupportMobile locale={props.locale} />
      <SupportDesktop locale={props.locale} onDownloadApp={props.onDownloadApp} />
    </section>
  );
}


function SupportMobile(props: X.PageProps) {
  // const tr = X.useTranslator();

  const content = useTravelerHomePage('supportClient')

  return (
    <div className={X.clsx(X.mobileOnly())}>
      <div className={X.clsx(
        "pl-mobile-margin mr-mobile-margin-half pr-mobile-margin-half",
        "bg-surface-green py-10 rounded-tr-4xl",
      )}>
        <ShopCard locale={props.locale} />
      </div>
      <div className={X.clsx("mr-mobile-margin bg-surface-green pl-mobile-margin-half")}>
        <div className={X.clsx("bg-white pl-mobile-margin-half rounded-tl-4xl py-10")}>

          <h3 className="text-[36px] mb-6 leading-tight">
            {/* {tr(data.support.title)} */}
            <ReactMarkdown components={{
              strong: ({ ...props }) => <strong {...props} className="font-medium" />,
            }}>
              {content.title}
            </ReactMarkdown>
          </h3>
          <div className="flex flex-row gap-4 items-start mb-4">
            {/* <p className="text-[16px] mb-6 leading-tight">
              {tr(data.support.text)}
              {content.content}
            </p> */}
            <div className="flex flex-col">

              <ReactMarkdown components={{
                p: ({ ...props }) => <p {...props} className="text-[16px] mb-6 leading-tight" />
              }}>
                {content.content}
              </ReactMarkdown>
            </div>
            {content.pictures[0] && <X.Image
              // src={SupportImage}
              src={content.pictures[0].url}
              width={content.pictures[0].width}
              height={content.pictures[0].height}
              unoptimized
              alt="Support" className="h-auto w-[47%] rounded-2xl" />}
          </div>

          <X.Button
            secondary
            href="/customer-service"
            // label={tr(data.support.cta)}
            label={content.cta as string}
          />

        </div>
      </div>
    </div>
  );
}


function SupportDesktop(props: X.PageProps<{
  onDownloadApp: () => void;
}>) {
  // const tr = X.useTranslator();
  const { ref, inView } = X.useInViewObserver<HTMLDivElement>();

  const content = useTravelerHomePage('supportClient')

  return (
    <div ref={ref} className={X.clsx(X.desktopOnly("block"), "max-w-content mx-auto relative h-[560px]")}>
      <div className={X.clsx(
        "bg-surface-green p-10 pb-20 rounded-t-4xl rounded-bl-4xl absolute left-0 top-0 right-[43%] pr-[116px]",
        "transition-transform duration-500 transform-gpu",
        inView ? "translate-x-0" : "-translate-x-[100vw]",
      )}>
        <ShopCard locale={props.locale} onDownloadApp={props.onDownloadApp} />
      </div>

      <div
        className={X.clsx(
          "absolute p-10 pb-25 pr-0 rounded-t-4xl right-0 top-10 max-w-[600px] bg-white",
          "transition-transform duration-500 transform-gpu",
          inView ? "translate-x-0" : "translate-x-[100vw]",
        )}
      >
        <h3 className="text-[48px] mb-16 leading-tight">
          {/* {tr(data.support.title)} */}
          <ReactMarkdown components={{
            strong: ({ ...props }) => <strong {...props} className="font-medium" />,
          }}>
            {content.title}
          </ReactMarkdown>
        </h3>
        <div className="flex gap-6 items-stretch">
          <div className="flex flex-col justify-between ">
            {/* <p className="text-[20px] mb-6">
              {tr(data.support.text)}
              {content.content}
            </p> */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <p {...props} className="text-[20px] mb-6" />
            }}>
              {content.content}
            </ReactMarkdown>
            <div className="relative">
              <X.Button
                secondary
                href="/customer-service"
                label="Service"
                className="!invisible"
                lg
              />
              <X.Button
                secondary
                href="/customer-service"
                // label={tr(data.support.cta)}
                label={content.cta as string}
                className="!absolute bottom-0 left-0"
                lg
              />
            </div>
          </div>
          {content.pictures[0] && <X.Image
            // src={SupportImage}
            src={content.pictures[0].url}
            unoptimized
            width={content.pictures[0].width}
            height={content.pictures[0].height}
            alt="Support"
            className="w-[215px] h-auto rounded-2xl"
          />}
        </div>
      </div>
    </div>
  );
}


function ShopCard(props: X.PageProps<{
  onDownloadApp?: () => void;
}>) {
  // const tr = X.useTranslator();
  const downloadUrl = X.useDownloadUrl(props.locale);
  const content = useTravelerHomePage('wayToBuy')
  return (
    <>
      <h3 className="text-[36px] max-w-[215px] xl:max-w-full xl:text-[48px] mb-6 xl:mb-8 leading-tight">
        {/* {tr(data.shop.title)} */}
        <ReactMarkdown components={{
          strong: ({ ...props }) => <strong {...props} className="font-medium" />,
        }}>
          {content.title}
        </ReactMarkdown>
      </h3>

      {/* <p className="text-[16px] xl:text-[20px] leading-tight xl:leading-normal mb-6">
        {content.message}
        {tr(data.shop.text)}
      </p> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <p {...props} className="text-[16px] xl:text-[20px] leading-tight xl:leading-normal mb-6" />
      }}>
        {content.message}
      </ReactMarkdown>
      <div className="flex flex-row gap-2 justify-between mb-8">
        {content.pictures.map((p) => <X.Image key={p.name} src={p.url} unoptimized width={10} height={p.height} alt={p.name} className="w-[48%] h-auto rounded-xl" />)}
        {/* <X.Image src={InStore1Image} alt="Store 1" className="w-[48%] h-auto" />
        <X.Image src={InStore2Image} alt="Store 2" className="w-[48%] h-auto" /> */}
      </div>
      {props.onDownloadApp ? (
        <X.Button
          primary
          label={content.cta}
          onClick={props.onDownloadApp}
          desktopLg
        />

      ) : (
        <X.Button
          primary
          exitHref={downloadUrl}
          label={content.cta}
          lg
        />
      )}
    </>
  );
}
